// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2FgxL","rootSmall":"AddTileButton_rootSmall__2PtRy"};